<template>
    <div>
        <Nav />

        <Banner />

        <Container />

        <Footer />
    </div>
</template>

<script>
import Nav from "@/components/Nav";
import Banner from "@/components/Banner";
import Container from "@/components/Container";
import Footer from "@/components/Footer";

export default {
    components: {
        Nav,
        Banner,
        Container,
        Footer
    }
};
</script>
